import * as React from 'react';

import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import { ROUTES } from '@utils/routes.ts';

import { useGtmPageView } from '@hooks/use-gtm-page-view';

import { Layout } from '@components/layout';
import { PrivateRoute } from '@components/private-route';

import { config } from '@/config.ts';

import { getRouteListForBrand } from './routes-config.tsx';
import { ScrollToTop } from './scroll-to-top.tsx';

function GtmPageViewWrapper() {
	useGtmPageView();
	return null;
}

const AppRoutes = () => {
	const routesList = getRouteListForBrand(config.BRAND);

	return (
		<BrowserRouter>
			<ScrollToTop />
			<GtmPageViewWrapper />
			<Routes>
				{routesList.map(route => (
					<Route
						key={route.key}
						path={route.path}
						element={
							<Layout isFullScreen={route.isFullscreen} hasNavigation={!route.isNavHidden}>
								{route.isPrivate ? <PrivateRoute>{route.element}</PrivateRoute> : route.element}
							</Layout>
						}
					/>
				))}
				<Route path='*' element={<Navigate to={ROUTES.HOME} replace />} />
			</Routes>
		</BrowserRouter>
	);
};

export default AppRoutes;
